module.exports = __webpack_public_path__ + "static/media/IMG_4286.41e4ea8e.PNG";